import { apiSlice } from "../apiSlice";

export const adminxxxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getUsersChangeByName: builder.query({
      query: (parameters) => ({
        url: `/Parmpoxx/Adminxxx/getUsers`,
        method: "GET",
        params: { ...parameters },
      }),
      providesTags: ["Create"],
    }),
    createHistory: builder.mutation({
      query: (parameters) => ({
        url: `/Parmpoxx/Adminxxx`,
        method: "POST",
        body: {
          ...parameters,
        },
      }),
      invalidatesTags: ["Create"],
    }),
    returnUser: builder.mutation({
      query: (parameters) => ({
        url: `/Parmpoxx/Adminxxx/` + parameters.SECINGID,
        method: "PUT",
        body: {
          ...parameters.body,
        },
      }),
      invalidatesTags: ["Create"],
    }),
    deleteHistory: builder.mutation({
      query: (SECINGID) => ({
        url: `/Parmpoxx/Adminxxx/` + SECINGID,
        method: "DELETE",
      }),
      invalidatesTags: ["Create"],
    }),
  }),
});

export const {
  useLazyGetUsersChangeByNameQuery,
  useCreateHistoryMutation,
  useReturnUserMutation,
  useDeleteHistoryMutation,
} = adminxxxApiSlice;
